import React from 'react';
import { toast } from 'react-hot-toast';
import './index.scss';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import OutlookSSO from '../../assets/outlook_sso.svg';

function Microsoft({ isLogin, setIsMicrosoftLogin }) {
  const { instance, accounts } = useMsal();

  const handleMicrosoftLogin = async () => {
    setIsMicrosoftLogin(true);
    // set a flag in local storage
    if (accounts.length > 0) {
      return;
    }
    localStorage.setItem('isMicrosoftLogin', true);
    try {
      instance.loginRedirect(loginRequest).catch((error) => {
        toast.error(error.message);
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div className="le-sso-microsoft" onClick={handleMicrosoftLogin}>
      <img src={OutlookSSO} alt="icon" />
      <div className="le-sso-microsoft-title">{isLogin ? 'Log In' : 'Continue'} With Outlook</div>
    </div>
  );
}

export default Microsoft;
